module.exports = __webpack_public_path__ + "img/12_dice[4].24389170.png";